/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CardLimitsTotal,
  CardLimitsTotalRequestDto,
  CardOrderResponse,
  CardResponse,
  CreateBulkCardsRequest,
  CreateCardRequest,
  CreateMigrationV2Payload,
  CreateSubscriptionMigrationCardsPayload,
  CreateSubscriptionMigrationRequest,
  GetCardParams2,
  GetSubscriptionMigrationsParams,
  SubscriptionCardOrderResponseDto,
  SubscriptionMigrationDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiCardsV2Controller<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name CreateBulkCards
   * @request POST:/api/v2/users/bulk-cards
   */
  createBulkCards = (data: CreateBulkCardsRequest, params: RequestParams = {}) =>
    this.http.request<CardOrderResponse[], any>({
      path: `/v2/users/bulk-cards`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createBulkCardsPath = '/v2/users/bulk-cards'
  static createBulkCardsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name CreateCard
   * @request POST:/api/v2/user/{userId}/card
   */
  createCard = (userId: string, data: CreateCardRequest, params: RequestParams = {}) =>
    this.http.request<CardOrderResponse, any>({
      path: `/v2/user/${userId}/card`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createCardPath = '/v2/user/${userId}/card'
  static createCardMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name GetSubscriptionMigrations
   * @request GET:/api/v2/subscription-migrations
   */
  getSubscriptionMigrations = (
    query: GetSubscriptionMigrationsParams,
    params: RequestParams = {},
  ) =>
    this.http.request<SubscriptionMigrationDto[], any>({
      path: `/v2/subscription-migrations`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getSubscriptionMigrationsPath = '/v2/subscription-migrations'
  static getSubscriptionMigrationsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name CreateMigration
   * @request POST:/api/v2/subscription-migrations
   */
  createMigration = (data: CreateSubscriptionMigrationRequest, params: RequestParams = {}) =>
    this.http.request<SubscriptionMigrationDto, any>({
      path: `/v2/subscription-migrations`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createMigrationPath = '/v2/subscription-migrations'
  static createMigrationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name CreateSubscriptionMigrationCards
   * @request POST:/api/v2/subscription-migrations/{subscriptionMigrationRequestId}/cards
   */
  createSubscriptionMigrationCards = (
    subscriptionMigrationRequestId: string,
    data: CreateSubscriptionMigrationCardsPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<SubscriptionCardOrderResponseDto[], any>({
      path: `/v2/subscription-migrations/${subscriptionMigrationRequestId}/cards`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createSubscriptionMigrationCardsPath =
    '/v2/subscription-migrations/${subscriptionMigrationRequestId}/cards'
  static createSubscriptionMigrationCardsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name CreateMigrationV2
   * @request POST:/api/v2/subscription-migrations/v2
   */
  createMigrationV2 = (data: CreateMigrationV2Payload, params: RequestParams = {}) =>
    this.http.request<SubscriptionMigrationDto, any>({
      path: `/v2/subscription-migrations/v2`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createMigrationV2Path = '/v2/subscription-migrations/v2'
  static createMigrationV2Method = 'POST'
  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name CalculateCardLimitsTotal
   * @request POST:/api/v2/card-limits/organisation/total
   */
  calculateCardLimitsTotal = (data: CardLimitsTotalRequestDto, params: RequestParams = {}) =>
    this.http.request<CardLimitsTotal, any>({
      path: `/v2/card-limits/organisation/total`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static calculateCardLimitsTotalPath = '/v2/card-limits/organisation/total'
  static calculateCardLimitsTotalMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name GetSubscriptionMigrationCardOrders
   * @request GET:/api/v2/subscription-migrations/{subscriptionMigrationRequestId}/card-orders
   */
  getSubscriptionMigrationCardOrders = (
    subscriptionMigrationRequestId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<SubscriptionCardOrderResponseDto[], any>({
      path: `/v2/subscription-migrations/${subscriptionMigrationRequestId}/card-orders`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getSubscriptionMigrationCardOrdersPath =
    '/v2/subscription-migrations/${subscriptionMigrationRequestId}/card-orders'
  static getSubscriptionMigrationCardOrdersMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cards-v-2-controller
   * @name GetCard
   * @request GET:/api/v2/card/{cardId}
   */
  getCard = ({ cardId, ...query }: GetCardParams2, params: RequestParams = {}) =>
    this.http.request<CardResponse, any>({
      path: `/v2/card/${cardId}`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getCardPath = '/v2/card/${cardId}'
  static getCardMethod = 'GET'
}
